// import { Message } from 'iview';
import axios from 'axios';
import qs from 'qs';
import sha1 from 'crypto-js/sha1';
import md5 from 'crypto-js/md5';
import { Base64 } from 'js-base64';

import envConfig from '../../config';
import { randomUUID } from 'cfmoto-utils';
import { getCustomAgent } from '@/utils';
function decodeDataComponent(str) {
  try {
    return decodeURIComponent(str);
  } catch (e) {
    return str;
  }
}

const baseURL = envConfig[`VUE_APP_${envConfig.env.toUpperCase()}_BASE_URL`];
const instance = axios.create({
  baseURL,
  timeout: 300000,
});

// 加签
instance.interceptors.request.use((request) => {
  console.log(request);
  console.log(request.url);
  console.log(request.params);
  console.log(Object.keys({ id: 3, iconUrl: 'https://cfmoto.oss-cn-hangzhou.aliyuncs.com/IMD/social/Icon/ic_hnl3.png', content: '发帖子分享骑行经历', type: 2, activeFlag: true, abledFlag: true }).sort());
  const appConfig = envConfig[`VUE_APP_${envConfig.env.toUpperCase()}_CONFIG`];
  const params = JSON.parse(JSON.stringify(request.params || {}));
  const query = qs.stringify(params, { arrayFormat: 'repeat', encode: false });
  const data = decodeDataComponent(!Object.keys(request.data || {}).length || request.data instanceof FormData ? '' : typeof request.data === 'string' ? request.data : JSON.stringify(request.data || ''));

  const queryError = /error/.test(window.location.href) ? '&error=' + new Date().getTime() : '';
  const nonce = randomUUID();
  const timestamp = new Date().getTime();
  const signature = `${query}${queryError}${data}appId=${appConfig.appId}&nonce=${nonce}&timestamp=${timestamp}${appConfig.appSecret}`;
  const signatureMd5 = md5(sha1(signature).toString()).toString();
  const signatureParam = `appId=${appConfig.appId}&nonce=${nonce}&timestamp=${timestamp}`;

  console.log(`=====  加签start =====`);
  console.log(`appId:${appConfig.appId}`);
  console.log(`appSecret:${appConfig.appSecret}`);
  console.log(`query:${query}`);
  console.log(`data:`, data);
  console.log(`nonce:${nonce}`);
  console.log(`timestamp:${timestamp}`);
  console.log(`signatureParam:${signatureParam}`);
  console.log(`拼接后：${signature}`);
  console.log(`加密后：${signatureMd5}`);

  // console.log(`=====  加签end =====`)

  request.headers['Cfmoto-X-Sign'] = `${signatureMd5}`;
  request.headers['Cfmoto-X-Sign-Type'] = `0`;
  request.headers['Cfmoto-X-Param'] = `${signatureParam}`;

  /* eslint-enable */
  return request;
});

// 响应拦截器
instance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

instance.interceptors.request.use(
  (request) => {
    /* eslint-disable no-param-reassign */
    if (request.params) {
      Object.keys(request.params).forEach((key) => {
        try {
          if (key !== 'dateTime') {
            request.params[key] = Base64.decode(request.params[key]);
          }
        } catch (e) {
          console.error(e);
        }
      });
    }
    if (request.data) {
      Object.keys(request.data).forEach((key) => {
        request.data[key] = Base64.decode(request.data[key]);
      });
    }
    if (!(request.params || request.data)) {
      const urlArr = request.url.split('/');
      urlArr[urlArr.length - 1] = Base64.decode(urlArr[urlArr.length - 1]);
      request.url = urlArr.join('/');
    }
    /* eslint-enable */
    return request;
  },
  (error) => {
    // do something with request error
    return Promise.reject(error);
  }
);

// token
instance.interceptors.request.use(async (request) => {
  /* eslint-disable */
  const ticket = JSON.parse(localStorage.getItem('token') || '""')
    .replace(/[bB]earer/, '')
    .trim();
  if (ticket && !request.headers['Authorization']) {
    request.headers.common['Authorization'] = `Bearer ${ticket}`;
  } else {
    request.headers.common['Authorization'] = `a1398a17-0890-4ab1-9df3-be9e2aa40615`;
  }
  request.headers['Zeeho-User-Agent'] = getCustomAgent();
  // request.headers['x-app-info'] = getCustomAgent();
  const user_id = JSON.parse(localStorage.getItem('user_id') || '""');
  if (user_id) {
    request.headers.common['user_id'] = user_id;
  }
  // request.headers.common['version'] = config.version;
  request.withCredentials = true;
  /* eslint-enable */
  return request;
});

export default instance;
